module.exports = __webpack_public_path__ + "static/sofiapro-medium-webfont-ff83c6cec388b55c363fb4c162c2c077.woff2";